// components/LiveCursor.tsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import NavigationOutlinedIcon from '@mui/icons-material/NavigationOutlined';

interface LiveCursorProps {
  x: number;
  y: number;
  userName: string;
  color: string;
}

const LiveCursor: React.FC<LiveCursorProps> = ({ x, y, userName, color }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        left: x,
        top: y,
        pointerEvents: 'none',
        zIndex: 1000,
        transform: 'translate(-2px, -2px)',
        transition: 'all 0.1s ease-out',
      }}
    >
      {/* Cursor SVG */}
      {/* <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))' }}
      >
        <path
          d="M5.5 3.21V20.8c0 .45.54.67.85.35L12 15.5l3.15 3.15c.31.31.85.09.85-.35V3.21c0-.45-.54-.67-.85-.35L12 6.65 8.35 2.86c-.31-.32-.85-.1-.85.35z"
          fill={color}
          stroke="white"
          strokeWidth="1"
        />
      </svg> */}
      <NavigationOutlinedIcon sx={{ color: color, transform: 'rotate(-25deg)' }} />
      {/* <svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))' }}
>
  <path
    d="M3.5 2.5 L16.5 11.5 L11.5 13.5 L13.5 21.5 L9.5 22.5 L7.5 14.5 L3.5 16.5 Z"
    fill="white"            
    stroke="black"
    strokeWidth="1"
    strokeLinejoin="round"
  />
  <path
    d="M7.5 14.5 L11.5 19.5"
    stroke="black"
    strokeWidth="1"
    strokeLinecap="round"
  />
</svg> */}

      
      {/* User name label */}
      <Typography
        variant="caption"
        sx={{
          position: 'absolute',
          left: 20,
          top: 20,
          backgroundColor: color,
          color: '#fff',
          px: 1,
          py: 0.5,
          borderRadius: 5,
          fontSize: '0.75rem',
          whiteSpace: 'nowrap',
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
        }}
      >
        {userName}
      </Typography>
    </Box>
  );
};

export default LiveCursor;
